// JS for handling sticky section navigation w/ x scroll overflow
const scrollContainer = document.querySelector('.js-section-nav-scroll-container');
const overflowButton = document.querySelector('.js-section-nav-scroll-btn');

function handleShowHideOverflowBtn() {
    // Show or hide button if contaienr has scroll overflow
    function showHideOverflowButton() {
        // If scroll width is greater than normal + padding
        if (scrollContainer.scrollWidth > (scrollContainer.offsetWidth + 24)) {
            overflowButton.classList.remove('tw-hidden');
        } else {
            overflowButton.classList.add('tw-hidden');
        }
    };

    showHideOverflowButton();
    window.addEventListener('resize', () => {
        showHideOverflowButton();
    });
}

function handleOverflowBtnClick() {
    // On click, scroll section nav
    function scrollElementLeft(element, units, duration) {
        let start = element.scrollLeft,
            change = start + units,
            currentTime = 0,
            increment = 20;

        //t = current time
        //b = start value
        //c = change in value
        //d = duration
        Math.easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1) { return c / 2 * t * t + b; }
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        };

        function animateScroll() {
            currentTime += increment;
            const val = Math.easeInOutQuad(currentTime, start, change, duration);
            element.scrollLeft = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    };

    function scrollSectionNavigation() {
        scrollElementLeft(scrollContainer, 125, 200);
    };

    overflowButton.addEventListener('click', scrollSectionNavigation);
}

function handleActiveSectionIndicator() {
    // Show active section in sticky nav on scroll
    const sectionNavItems = scrollContainer.querySelectorAll('a[href^="#"]');
    const sectionDividers = document.querySelectorAll('.twc-divider[id]');

    function listenForActiveSection() {
        sectionDividers.forEach((sectionDivider) => {
            const sectionNavItem = scrollContainer.querySelector(`a[href="#${sectionDivider.id}"]`);
            var otherSectionNavItems = scrollContainer.querySelectorAll(`a:not([href="#${sectionDivider.id}"])`);
            const sectionIsActiveFromTop = sectionDivider.getBoundingClientRect().top < 135 && sectionDivider.getBoundingClientRect().top > 0;
            const sectionIsActiveFromBottom = sectionDivider.getBoundingClientRect().top < 235 && sectionDivider.getBoundingClientRect().top > 136;

            // Mark section as active if close to top of screen
            if (sectionIsActiveFromTop && sectionNavItem) {
                sectionNavItem.classList.add('js-active-section');
                otherSectionNavItems.forEach((otherSectionNavItem) => {
                    otherSectionNavItem.classList.remove('js-active-section');
                });
            }

            // Mark previous section as active if scrolling back up
            if (sectionIsActiveFromBottom && sectionNavItem) {
                // Get index of current nav item
                const sectionNavItemIndex = [].indexOf.call(sectionNavItems, sectionNavItem);
                // Make the previous one active
                if (sectionNavItemIndex > 0) {
                    const prevSectionNavItem = sectionNavItems[sectionNavItemIndex - 1];
                    prevSectionNavItem.classList.add('js-active-section');

                    let otherSectionNavItems = scrollContainer.querySelectorAll(`a:not([href="${prevSectionNavItem.getAttribute("href")}"])`);
                    otherSectionNavItems.forEach((otherSectionNavItem) => {
                        otherSectionNavItem.classList.remove('js-active-section');
                    });
                }
            }
        })
    }

    document.addEventListener("scroll", listenForActiveSection);

}

function main() {
    if (scrollContainer) {
        handleShowHideOverflowBtn();
        handleOverflowBtnClick();
        handleActiveSectionIndicator();
    }
}

export default function () {
    main();
}
